import { defineNuxtRouteMiddleware, useCookie, navigateTo, useNuxtApp } from '#imports'

export default defineNuxtRouteMiddleware((to) => {
	const auth = useCookie('auth').value
	const store = useNuxtApp().$store

	const noAuthRequired = ['login', 'login-password-forgot', 'login-password-reset', 'sign-up']
	// Specific case for Shopify install
	if ('shopify-install' === to.name) return
	else if (to.name && to.name.includes('onboarding')) return
	else if (noAuthRequired.includes(to.name) && store.state.auth) return navigateTo('/home')
	else if (noAuthRequired.includes(to.name)) return

	if (!auth || !store.state.auth) {
		store.dispatch('login/logout')
		return navigateTo('/login')
	}
})
